/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetDailyExchangeRateQueryVariables = Types.Exact<{
    currency: Types.Scalars['String'];
}>;

export type GetDailyExchangeRateQuery = { __typename: 'Query'; dailyExchangeRate: number };

export const GetDailyExchangeRateDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetDailyExchangeRate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'currency' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dailyExchangeRate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'currency' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'currency' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export type GetDailyExchangeRateComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetDailyExchangeRateQuery,
        GetDailyExchangeRateQueryVariables
    >,
    'query'
> &
    ({ variables: GetDailyExchangeRateQueryVariables; skip?: boolean } | { skip: boolean });

export const GetDailyExchangeRateComponent = (props: GetDailyExchangeRateComponentProps) => (
    <ApolloReactComponents.Query<GetDailyExchangeRateQuery, GetDailyExchangeRateQueryVariables>
        query={GetDailyExchangeRateDocument}
        {...props}
    />
);

/**
 * __useGetDailyExchangeRateQuery__
 *
 * To run a query within a React component, call `useGetDailyExchangeRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyExchangeRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyExchangeRateQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetDailyExchangeRateQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetDailyExchangeRateQuery,
        GetDailyExchangeRateQueryVariables
    >
) {
    return Apollo.useQuery<GetDailyExchangeRateQuery, GetDailyExchangeRateQueryVariables>(
        GetDailyExchangeRateDocument,
        baseOptions
    );
}
export function useGetDailyExchangeRateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetDailyExchangeRateQuery,
        GetDailyExchangeRateQueryVariables
    >
) {
    return Apollo.useLazyQuery<GetDailyExchangeRateQuery, GetDailyExchangeRateQueryVariables>(
        GetDailyExchangeRateDocument,
        baseOptions
    );
}
export type GetDailyExchangeRateQueryHookResult = ReturnType<typeof useGetDailyExchangeRateQuery>;
export type GetDailyExchangeRateLazyQueryHookResult = ReturnType<
    typeof useGetDailyExchangeRateLazyQuery
>;
export type GetDailyExchangeRateQueryResult = Apollo.QueryResult<
    GetDailyExchangeRateQuery,
    GetDailyExchangeRateQueryVariables
>;
